import axiosinstance from './axiosins'

/**
 *
 * @param {Object} payload
 *
 * Network Connection established.
 */
export const postapicallnetworkservice = async (method, apiUrl, payload = {},responseType = {} ) => {
  return axiosinstance.post(apiUrl, payload,responseType)
    .then((data) => {
      return Promise.resolve(data)
    })
    .catch((err) => {
      if (err.code === 'ECONNABORTED') {
        return Promise.reject({'data':{'status':110,'msg':'Request Timeout'}})
      }else{
        return Promise.reject({'data':{'status':500,'msg':'Internal Server Error'}})
      }
    })
}


/**
 *
 * @param {Object} payload
 *
 * Network Connection established.
 */
export const getapicallnetworkservice = async (method, apiUrl, payload = {}) => {
  return axiosinstance.get(apiUrl, payload)
    .then((data) => {
      return Promise.resolve(data)
    })
    .catch((err) => {
      return Promise.reject(false)
    })
}

// export const apicallnetworkservice = (method, apiUrl, payload = {}) => {
//
//    return axiosinstance.`${method}`(`${apiUrl}`,payload)
//    .then((data) => {
//         return Promise.resolve(data)
//    })
//    .catch((err) => {
//        return Promise.reject(false)
//    })
//
// }



//////////////////
// WEBPACK FOOTER
// ./services/apicallservice.js
// module id = 200
// module chunks = 1